import { Link, useNavigate } from "react-router-dom"
import enLang from "../../assets/lang.svg"
import profileImg from "../../assets/Rectangle 1393.png"
import profile from "../../assets/profile-add.svg"
// import notifications from "../../assets/clarity_notification-line.png"
import { BsList } from "react-icons/bs"; // Using Bootstrap List Icon
import Offcanvas from 'react-bootstrap/Offcanvas';
import "./AuthNavbar.css"
import { useDispatch, useSelector } from "react-redux";
import { changeLocal } from "../../hooks/Localization";
import { loginMethod } from "../../hooks/auth"
import Sidebar from "../../components/Sidebar/Sidebar"
import { useEffect, useState } from "react"
import home from "../../assets/home-2.svg"
import bank from "../../assets/bank.svg"
//  import profile from "../../assets/profile-add.svg"
// import home from "../../assets/home-2.svg"
import mingcute from "../../assets/mingcute_classify-add-fill.svg"
import axios from "axios";
// import teacher from "../../assets/teacher.svg"

function AuthNavbar() {
  const { currentLocal } = useSelector((state) => state.currentLocal);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const dispatch = useDispatch();
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [show, setShow] = useState(false);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [data, setData] = useState([])
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const userinfo = useSelector((state) => state.auth?.userArray?.user);
  const token = useSelector((state) => state.auth?.userArray.access_token);

  // const sidebarItems = userinfo && userinfo.role === "Super Admin" ? [
  //     { name: currentLocal.home.dashboard, icon: home, path: "dashboard" },
  //     { name: currentLocal.home.schools, icon: bank, path: "Schools" },
  //     { name: currentLocal.home.settings, icon: bank,path:"settings" },




  //   ] : userinfo && userinfo.role === "School Manager" ? [

  //     { name: currentLocal.home.dashboard, icon: home, path: "dashboard" },
  //     {
  //       name:currentLocal.home.SchoolStracture , icon: profile, path: "school-structure", subTabs: [
  //         { name: currentLocal.home.stages, icon: profile, path: "structure/stages" },
  //         { name: currentLocal.home.grades, icon: profile, path: "structure/grades" }
  //       ]
  //     },
  //     { name:currentLocal.home.subjects, icon: profile, path: "Subjects" },
  //     { name:currentLocal.home.teachers , icon: profile, path: "Teachers" },

  //     { name: currentLocal.home.classes, icon: profile, path: "Classes" },
  //     { name:currentLocal.home.students , icon: profile, path: "Students" },
  //     { name:currentLocal.home.attendanceHistory, icon: profile, path: "attendance-history" },





  //   ] : [
  //     { name: currentLocal.home.dashboard, icon: home, path: "dashboard" },
  //     { name:currentLocal.home.markAttendance, icon: profile, path: "mark-attendance" },
  //     // { name: "Attendance History", icon: mingcute,path:"attendance-history" },
  //   ]

  const sidebarItems = localStorage.getItem("type") == "admin" ?

    [
      { name: currentLocal.home.dashboard, icon: home, path: "dashboard" },
      // { name: currentLocal.home.Generaldata, icon: bank, path: "products" },
      // { name: currentLocal.home.Finance, icon: bank,path:"codes" },
      {
        name: currentLocal.home.Finance, icon: profile, path: "code", subTabs: [
          // { name: currentLocal.home.all, icon: profile, path: "finance/all" },
          { name: currentLocal.home.Sales, icon: profile, path: "finance" },
          { name: currentLocal.home.Purchases, icon: profile, path: "Purchases" },
          { name: currentLocal.home.Salaries, icon: profile, path: "salaries" },
          { name: currentLocal.home.Maintenance, icon: profile, path: "maintenance" },
        ]
      },
      {
        name: currentLocal.home.Studyexpenses, icon: profile, path: "expenses/all",

      },
      { name: currentLocal.home.Presenceandabsence, icon: bank, path: "tarteeb" },
      { name: currentLocal.home.Teacherreserve, icon: bank, path: "teacherreserve" },
      { name: currentLocal.home.settings, icon: bank, path: "settings" },


    ] : localStorage.getItem("type") == "maintenance" ?



      [
        { name: currentLocal.home.dashboard, icon: home, path: "dashboard" },
        { name: currentLocal.home.Maintenance, icon: profile, path: "maintenance" },


      ] : localStorage.getItem("type") == "salaries" ?



        [
          { name: currentLocal.home.dashboard, icon: home, path: "dashboard" },
          { name: currentLocal.home.Salaries, icon: profile, path: "salaries" },


        ]
        : localStorage.getItem("type") == "sales" ?



          [
            { name: currentLocal.home.dashboard, icon: home, path: "dashboard" },
            { name: currentLocal.home.Salaries, icon: profile, path: "salaries" },
            { name: currentLocal.home.students, icon: profile, path: "student/Finance" },


            {
              name: currentLocal.home.Studyexpenses, icon: profile, path: "code1", subTabs: [
                { name: currentLocal.home.all, icon: profile, path: "expenses/all" },
                { name: currentLocal.home.Exceptions, icon: profile, path: "expenses/exceptions" },
              ]
            },


          ]
          : localStorage.getItem("type") == "purchases" ?



            [
              { name: currentLocal.home.dashboard, icon: home, path: "dashboard" },
              { name: currentLocal.home.Purchases, icon: profile, path: "Purchases" },


            ]
            : localStorage.getItem("type") == "financial" ?

              [
                { name: currentLocal.home.dashboard, icon: home, path: "dashboard" },
                // { name: currentLocal.home.Generaldata, icon: bank, path: "products" },
                // { name: currentLocal.home.Finance, icon: bank,path:"codes" },
                {
                  name: currentLocal.home.Finance, icon: profile, path: "code", subTabs: [
                    { name: currentLocal.home.all, icon: profile, path: "finance/all" },
                    { name: currentLocal.home.Sales, icon: profile, path: "finance" },
                    { name: currentLocal.home.Purchases, icon: profile, path: "Purchases" },
                    { name: currentLocal.home.Salaries, icon: profile, path: "salaries" },
                    { name: currentLocal.home.Maintenance, icon: profile, path: "maintenance" },
                  ]
                },
                {
                  name: currentLocal.home.Studyexpenses, icon: profile, path: "expenses/all",

                },
                // { name: currentLocal.home.Presenceandabsence, icon: bank,path:"tarteeb" },
                // { name: currentLocal.home.Teacherreserve, icon: bank,path:"teacherreserve" },
                // { name: currentLocal.home.settings, icon: bank,path:"settings" },


              ]
              : [

                { name: currentLocal.home.dashboard, icon: home, path: "dashboard" },
                { name: currentLocal.home.Finance, icon: bank, path: "student/Finance" },
                { name: currentLocal.home.timeTable, icon: bank, path: "TimeTable" },
                { name: currentLocal.home.forms, icon: bank, path: "forms" },

                // { name: currentLocal.home.tests, icon: bank,path:"tests" },
                { name: currentLocal.home.attendanceHistory, icon: bank, path: "AttendanceHistory" },




              ]
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const navigate = useNavigate();
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const handleLang = () => {
    dispatch(
      changeLocal(
        currentLocal.language === "English" ? "ar" : "en"
      )
    );
  }
  const handleLogout = () => {
    dispatch(loginMethod({}))
    navigate('/login')
    localStorage.setItem("type", "");

  }
  const getData = async () => {
    try {
      const response = await axios.get(
        "https://nanosoft.space/taarteb/public/api/notification/all",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = response.data.data;

      // هنجمع كل الـ arrays اللي جواه
      const merged = Object.values(data).flat();



      setData(merged.filter((item) => item?.read_at == null));

    } catch (error) {
      console.log(error);
    }
  }
  useEffect(() => {
    getData()
  }, [])
  const handleChangeRole = (role) => {
    if (role == "Purchasing Employee") {
      localStorage.setItem("type", "purchases");
      navigate("/dashboard/dashboard");
    } else if (role == "Maintenance Employee") {
      localStorage.setItem("type", "maintenance");
      navigate("/dashboard/dashboard");


    } else if (role == "Salaries Employee") {
      localStorage.setItem("type", "salaries");
      navigate("/dashboard/dashboard");

    }
    else if (role == "Sales Employee") {
      localStorage.setItem("type", "sales");
      navigate("/dashboard/dashboard");

    }
    else if (role == "Financial Director") {
      localStorage.setItem("type", "financial");
      navigate("/dashboard/dashboard");

    }
    else if (role == "School Manager") {
      localStorage.setItem("type", "admin");
      navigate("/dashboard/dashboard");

    }

    // لو عايز تحديث فوري
    window.location.reload();
  };

  const rolesArray = Array.isArray(userinfo?.role)
    ? userinfo.role
    : userinfo?.role
      ? [userinfo.role]
      : [];
  return (
    <div className="authNavbar_container ">
      <div className="w-100 d-flex align-items-center justify-content-between py-3">
        <div>
          <div className="mx-2 list_container" onClick={handleShow}>
            <BsList size={24} />
          </div>
          <Offcanvas show={show} onHide={handleClose}>
            <Offcanvas.Header closeButton style={{ backgroundColor: "#2D103A" }}>
            </Offcanvas.Header>
            <Offcanvas.Body className="p-0">
              <Sidebar
                sidebarItems={sidebarItems}
              />
            </Offcanvas.Body>
          </Offcanvas>
        </div>

        <div className="d-flex  align-items-center ">
          <div>
            <div className="nav-item dropdown d-flex justify-content-center align-items-center">
              <Link className="nav-link dropdown-toggle d-flex justify-content-center align-items-center" to="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                <img src={enLang} alt="" className="w-75" />

                {currentLocal.language}
              </Link>
              <ul className="dropdown-menu">
                <li><div className="dropdown-item  d-flex align-items-center"
                  onClick={handleLang}
                >
                  <img src={enLang} alt="" className="w-25 me-2" />

                  {currentLocal && currentLocal.language === "English" ? currentLocal.home.language : currentLocal.home.switchTo
                  }


                </div></li>
              </ul>
            </div>
          </div>
          <div className="mx-3">
            <Link to={"/dashboard/notifications"} style={{ position: "relative" }}>
              <div className="bg-danger text-white d-flex justify-content-center align-items-center rounded-circle px-2" style={{ position: "absolute", bottom: "15px", left: "10px" }}>{data?.length}</div>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="gray" className="bi bi-bell-fill" viewBox="0 0 16 16">
                <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2m.995-14.901a1 1 0 1 0-1.99 0A5 5 0 0 0 3 6c0 1.098-.5 6-2 7h14c-1.5-1-2-5.902-2-7 0-2.42-1.72-4.44-4.005-4.901" />
              </svg>
            </Link>
          </div>
          <div className="mx-3">
            <div className="nav-item dropdown d-flex justify-content-center align-items-center">
              <Link className="nav-link dropdown-toggle d-flex justify-content-center align-items-center" to="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                <img src={profileImg} alt="" className="w-75" />


              </Link>
              <ul className="dropdown-menu">
                <li className="d-flex mx-2 border-bottom pb-2">
                  <img src={profileImg} alt="" className="w-25" />
                  <div className="ms-2 me-2">
                    <p className="mb-0 user_name">{userinfo?.name.slice(0, 10)}..</p>
                    {/* <p className="mb-0 user_type">{Array.isArray(userinfo?.role) ? userinfo?.role[0] : userinfo?.role}<br /></p> */}
                    <p className="mb-0 user_type">
                      {localStorage.getItem("type")}
                    </p>
                  </div>
                </li>
                <li>
                  {rolesArray.length > 1 && (
                    <>
                      <li className="dropdown-header text-end">
                        {currentLocal.home.switchtoAccount}
                      </li>

                    {rolesArray
  .filter(role => role !== "Other")
  .map((role, index) => {
                        console.log(role);
                        
                        return(
                        <li key={index}>
                          <div
                            className="dropdown-item d-flex align-items-center"
                            style={{
                              cursor: "pointer",
                              fontWeight:
                                localStorage.getItem("type") === role ? "bold" : "normal",
                            }}
                            onClick={() => handleChangeRole(role)}
                          >
                                <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24" version="1.1" className="svg-main-icon">
                        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                          <polygon points="0 0 24 0 24 24 0 24"></polygon>
                          <path d="M12,11 C9.790861,11 8,9.209139 8,7 C8,4.790861 9.790861,3 12,3 C14.209139,3 16,4.790861 16,7 C16,9.209139 14.209139,11 12,11 Z" fill="#000000" fillRule="nonzero" opacity="0.3"></path>
                          <path d="M3.00065168,20.1992055 C3.38825852,15.4265159 7.26191235,13 11.9833413,13 C16.7712164,13 20.7048837,15.2931929 20.9979143,20.2 C21.0095879,20.3954741 20.9979143,21 20.2466999,21 C16.541124,21 11.0347247,21 3.72750223,21 C3.47671215,21 2.97953825,20.45918 3.00065168,20.1992055 Z" fill="var(--primary)" fillRule="nonzero"></path>
                        </g>
                      </svg>
                        {role}
                          </div>
                        </li>
                      )})}
                    </>
                  )}

                </li>
                <li className="py-2">


                  <Link to="/dashboard/profile">
                    <div className="dropdown-item  d-flex align-items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24" version="1.1" className="svg-main-icon">
                        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                          <polygon points="0 0 24 0 24 24 0 24"></polygon>
                          <path d="M12,11 C9.790861,11 8,9.209139 8,7 C8,4.790861 9.790861,3 12,3 C14.209139,3 16,4.790861 16,7 C16,9.209139 14.209139,11 12,11 Z" fill="#000000" fillRule="nonzero" opacity="0.3"></path>
                          <path d="M3.00065168,20.1992055 C3.38825852,15.4265159 7.26191235,13 11.9833413,13 C16.7712164,13 20.7048837,15.2931929 20.9979143,20.2 C21.0095879,20.3954741 20.9979143,21 20.2466999,21 C16.541124,21 11.0347247,21 3.72750223,21 C3.47671215,21 2.97953825,20.45918 3.00065168,20.1992055 Z" fill="var(--primary)" fillRule="nonzero"></path>
                        </g>
                      </svg>
                      {currentLocal.home.profile}


                    </div>
                  </Link>


                </li>
                <li className="py-2">
                  <Link to="/dashboard/change-password">
                    <div className="dropdown-item  d-flex align-items-center" >
                      <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24" version="1.1" className="svg-main-icon">
                        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                          <polygon points="0 0 24 0 24 24 0 24"></polygon>
                          <path d="M12,11 C9.790861,11 8,9.209139 8,7 C8,4.790861 9.790861,3 12,3 C14.209139,3 16,4.790861 16,7 C16,9.209139 14.209139,11 12,11 Z" fill="#000000" fillRule="nonzero" opacity="0.3"></path>
                          <path d="M3.00065168,20.1992055 C3.38825852,15.4265159 7.26191235,13 11.9833413,13 C16.7712164,13 20.7048837,15.2931929 20.9979143,20.2 C21.0095879,20.3954741 20.9979143,21 20.2466999,21 C16.541124,21 11.0347247,21 3.72750223,21 C3.47671215,21 2.97953825,20.45918 3.00065168,20.1992055 Z" fill="var(--primary)" fillRule="nonzero"></path>
                        </g>
                      </svg>
                      {currentLocal.home.changePassword}

                    </div>
                  </Link>


                </li>
                <li className="border-top pt-2">
                  <div className="dropdown-item  d-flex align-items-center" onClick={handleLogout}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--primary)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
                    {currentLocal.home.logout}

                  </div>

                </li>
              </ul>
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}

export default AuthNavbar


